/**
 * Shown while the agent is working but no assistant row exists yet (before streamed answer replaces this).
 */
import { AssistantHandraiseRow } from "@/components/ui/chat/AssistantHandraiseRow";

const ThinkingBubble = () => (
  <AssistantHandraiseRow>
    <div className="animate-shimmer text-sm leading-relaxed text-gray-500">
      Thinking…
    </div>
  </AssistantHandraiseRow>
);

export default ThinkingBubble;
